import axios from '../axios'
import appConfig from 'app.config'
import { getHeadersWithJwtToken } from 'auth/utils/auth-util'
import { logError } from 'shared/AppInsight'
import { CountryA3 } from 'shared/constants/countryTypes'

export interface CashToAccountPreliminaryParams {
	partyId: string
	accountAgreementId: string
	market: CountryA3 | undefined
}

export interface CashToAccountPreliminaryResponse {
	state: 'Unknown' | 'Approved' | 'Denied' | 'Investigation'
	message: string | null | undefined
}

export async function cashToAccountPreliminary(
	params: CashToAccountPreliminaryParams,
) {
	return axios
		.post<CashToAccountPreliminaryResponse>(
			`${appConfig.customerDataBaseUrl}/api/CashToAccount/decision/preliminary`,
			params,
			await getHeadersWithJwtToken(),
		)
		.then(({ data }) => data)
		.catch((err) => {
			logError(err)
			throw err
		})
}
